<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Sub Departemen</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Data Sub Departemen</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-between mb-2">
        <div>
          <AutoComplete
            ref="divisi"
            v-model="selectedDivisi"
            placeholder="Search Divisi"
            :suggestions="listDivisi"
            field="name"
            @complete="searchDivisi"
            @item-select="onSelectDivisi"
            @focus="selectAllText('divisi')"
            @keydown="handleKeydownField($event, 'departemen')"
          >
            <template v-if="selectedDivisi" #selected-item>
              <div class="selected-data">
                {{ selectedDivisi.name }}
                <i class="pi pi-times close-icon" @click="clearSelection"></i>
              </div>
            </template>
          </AutoComplete>
          <AutoComplete
            ref="departemen"
            v-model="selectedDepartemen"
            placeholder="Search Departemen"
            :suggestions="listDepartemen"
            field="name"
            class="pl-2"
            @complete="searchDepartemen"
            @item-select="onSelectDepartemen"
            @focus="selectAllText('departemen')"
          >
            <template v-if="selectedDepartemen" #selected-item>
              <div class="selected-data">
                {{ selectedDepartemen.name }}
                <i class="pi pi-times close-icon" @click="clearSelection"></i>
              </div>
            </template>
          </AutoComplete>
        </div>
        <div>
          <Button
            icon="pi pi-plus"
            label="Sub Departemen"
            :disabled="!this.parent_ref"
            @click="onAddData"
          />
          <Button
            type="button"
            icon="pi pi-refresh"
            label="Reset"
            class="p-button-outlined ml-2"
            @click="clearFilter()"
          />
        </div>
      </div>
      <fx-table
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
      >
        <template #columns>
          <Column
            field="ctg"
            header="Kode Sub Departemen"
            style="min-width: 18rem"
            sortable
            :filter-match-mode-options="equalModesOption"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="name"
            header="Nama Sub Departemen"
            style="min-width: 15rem"
            sortable
            :filter-match-mode-options="containModesOption"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="std_mrg"
            header="Std Margin"
            style="min-width: 8rem; justify-content: flex-end"
          >
            <template #body="{ data }"> {{ data.std_mrg }}% </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-outlined p-button-danger p-button-text"
                @click="onConfirmDeletion(data)"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      :header="
        form && form.id > 0 ? 'Edit Sub Departemen' : 'Tambah Sub Departemen'
      "
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-sub-departemen
        :item="form"
        :loading="isLoadingSave"
        :editMode="editMode"
        :list-divisi="listDivisi"
        :list-departemen="listDepartemen"
        @save="onSaveData"
        @close="dialog = false"
      />
    </Dialog>
    <Dialog
      header="Hapus Sub Departemen"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Sub Departemen <strong>{{ form.nama }}</strong> akan dihapus. Proses
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteSubDepartemen"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import { handleKeydownField } from '@/helpers'
import DivisiService from '@/services/DivisiService'
import DepartemenService from '@/services/DepartemenService'
import SubDepartemenService from '@/services/SubDepartemenService'
import FormSubDepartemen from '@/components/master/FormSubDepartemen'
import FxTable from '@/components/FxTable'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'SubDepartemen',
  components: {
    FormSubDepartemen,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      parent_divisi_id: 0,
      parent_departemen_id: 0,
      parent_ref: null,
      parent_std_mrg: 0,
      selectedDivisi: [],
      selectedDepartemen: [],
      divisiService: null,
      departemenService: null,
      subDepartemenService: null,
      dialog: false,
      dialogHapus: false,
      isLoading: false,
      editMode: false,
      isLoadingSave: false,
      listDivisi: [],
      listDepartemen: [],
      items: [],
      subDepartemen: [],
      totalRecords: 0,
      form: {
        id: 0,
        parent_ref: null,
        parent_id: 0,
        ctg: '',
        name: null,
        std_mrg: null,
      },
      options: {
        page: 1,
        rows: 10,
        sortField: 'ctg',
        sortOrder: '1',
        filters: {},
      },
      filters: {
        ctg: { value: null, matchMode: FilterMatchMode.EQUALS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      containModesOption: [
        { label: 'Contains', value: FilterMatchMode.CONTAINS },
      ],
      equalModesOption: [{ label: 'Equals', value: FilterMatchMode.EQUALS }],
    }
  },
  created() {
    this.divisiService = new DivisiService()
    this.departemenService = new DepartemenService()
    this.subDepartemenService = new SubDepartemenService()
  },
  async mounted() {
    this.loadData()
  },
  methods: {
    selectAllText(event) {
      if (event) {
        this.$refs[event].$el.querySelector('input').select()
      }
    },
    clearFilter() {
      this.selectedDivisi = []
      this.selectedDepartemen = []
      this.parent_divisi_id = 0
      this.parent_departemen_id = 0
      this.loadData()
    },
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      const divisi = this.listDivisi.find(
        (div) => div.id === this.parent_divisi_id
      )

      const departemen = this.listDepartemen.find(
        (dept) => dept.id === this.parent_departemen_id
      )

      this.parent_ref =
        divisi && departemen ? `${divisi.ctg}-${departemen.ctg}` : null

      this.subDepartemenService
        .paginate(page, perPage, sortField, sortOrder, this.parent_ref, filters)
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Sub Departemen', this)
        })
        .finally(() => (this.isLoading = false))
    },
    async searchDivisi(event) {
      const search = event.query
      await this.divisiService
        .getList(search)
        .then((res) => {
          this.listDivisi = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Divisi', this)
        })
    },
    onSelectDivisi() {
      if (this.selectedDivisi) {
        this.parent_divisi_id = this.selectedDivisi.id
        this.items = []
        this.selectedDepartemen = []
        this.$nextTick(() => {
          this.$refs.divisi.$el.querySelector('input').blur()
        })
      }
    },
    async searchDepartemen(event) {
      this.parent_departemen_id = 0
      const search = event.query
      await this.departemenService
        .getList(this.parent_divisi_id, search)
        .then((res) => {
          this.listDepartemen = res.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Departemen', this)
        })
    },
    onSelectDepartemen() {
      if (this.selectedDepartemen) {
        this.parent_departemen_id = this.selectedDepartemen.id
        this.parent_std_mrg = this.selectedDepartemen.std_mrg
        this.$nextTick(() => {
          this.$refs.departemen.$el.querySelector('input').blur()
        })
        this.loadData()
      }
    },
    onEditData(data) {
      this.editMode = true
      this.form.parent_divisi = this.parent_divisi_id
        ? this.parent_divisi_id
        : parseInt(data.parent_ref.split('-')[0])
      this.form.parent_departemen = data.parent_id

      this.divisiService
        .getById(`/${this.form.parent_divisi}`)
        .then((res) => {
          this.listDivisi = [res.data.data]
        })
        .catch((err) => {
          errorHandler(err, 'Data Divisi', this)
        })
      this.departemenService
        .getById(`/${this.form.parent_departemen}`)
        .then((res) => {
          this.listDepartemen = [res.data.data]
        })
        .catch((err) => {
          errorHandler(err, 'Data Departemen', this)
        })

      this.form.id = data.id
      this.form.parent_ref = data.parent_ref
      this.form.parent_id = data.parent_id
      this.form.ctg = data.ctg
      this.form.name = data.name
      this.form.std_mrg = data.std_mrg
      this.dialog = true
    },
    onAddData() {
      this.editMode = false
      this.form.parent_divisi = this.parent_divisi_id
      this.form.parent_departemen = this.parent_departemen_id

      this.form.id = 0
      this.form.parent_ref = this.parent_ref
      this.form.parent_id = this.parent_departemen_id
      this.form.id = 0
      this.form.ctg = null
      this.form.name = null
      this.form.std_mrg = this.parent_std_mrg
      this.dialog = true
    },
    onSaveData(data) {
      this.isLoadingSave = true
      let item = {}
      item.parent_id = data.parent_id
      item.parent_ref = data.parent_ref
      item.level = 'SUBDEPT'
      item.ctg = data.ctg === null ? '' : data.ctg
      item.name = data.name
      item.std_mrg = data.std_mrg

      if (data.id == 0) {
        this.subDepartemenService
          .add(item)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Data Sub Departemen',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data Sub Departemen', this)
          })
          .finally(() => (this.isLoadingSave = false))
      } else {
        this.subDepartemenService
          .update(data.id, item)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Data Sub Departemen',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data Sub Departemen', this)
          })
          .finally(() => (this.isLoadingSave = false))
      }
    },
    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeleteSubDepartemen() {
      this.subDepartemenService
        .delete(this.form.id)
        .then((res) => {
          if (res.status === 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'Data Sub Departemen',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
          }
          this.loadData()
        })
        .catch((err) => {
          errorHandler(err, 'Data Sub Departemen', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddData()
      }
    },
    handleKeydownField(event, nextRef, selectAll = false) {
      handleKeydownField(this, event, nextRef, selectAll)
    },
  },
}
</script>
